module.exports = __webpack_public_path__ + "img/92170.d1566c3e.svg";